import React, { useContext } from "react"
import Link from "components/i18n/Link"
import { Box, Container, Typography, Grid } from "@mui/material"
import Icon from "@mdi/react"
import {
	mdiCellphone,
	mdiTruck,
	mdiCogs,
	mdiCreditCardMarkerOutline,
	mdiFaceAgent,
	mdiScriptTextOutline,
	mdiRuler,
} from "@mdi/js"

import SEO from "@secureo/common/components/SEO"
import BreadCrumbs, { BreadCrumb } from "components/BreadCrumbs"

import { CustomAppProps } from "pages/_app"
import AppContext from "@secureo/common/context/AppContext/AppContext"

export const helpCenterAncestorBreadCrumbs: BreadCrumb[] = [
	{
		href: "/help",
		label: "Hilfe",
	},
]

const helpCenterLinks = [
	{
		title: "Kontakt",
		description: "",
		url: "/help/contact",
		icon: mdiCellphone,
	},
	{
		title: "Warum mit uns?",
		description: "",
		url: "/help/why-choose-us",
		icon: mdiTruck,
	},
	{
		title: "Hersteller",
		description: "",
		url: "/brands",
		icon: mdiCogs,
	},
	{
		title: "Versand & Zahlung",
		description: "",
		url: "/help/shipping-and-payment",
		icon: mdiCreditCardMarkerOutline,
	},
	{
		title: "Zylinder messen",
		description: "",
		url: "/help/how-to-measure-cylinders",
		icon: mdiRuler,
	},
	{
		title: "Gewerbekunden",
		description: "",
		url: "/help/business-customers",
		icon: mdiFaceAgent,
	},
	{
		title: "Impressum & Datenschutz",
		description: "",
		url: "/help/imprint",
		icon: mdiScriptTextOutline,
	},
	{
		title: "AGB",
		description: "",
		url: "/help/terms-and-conditions",
		icon: mdiScriptTextOutline,
	},
	{
		title: "Widerrufsbelehrung",
		description: "",
		url: "/help/cancellation-policy",
		icon: mdiScriptTextOutline,
	},
]

const HelpCenterPage = ({ asPath, locale }: CustomAppProps) => {
	const { isLoggedIn, customer } = useContext(AppContext)

	const firstName = customer?.firstName ?? ""

	const currentPath: BreadCrumb = {
		href: "/help",
		label: "Hilfe",
	}

	return (
		<>
			<SEO asPath={asPath} appendLocalizedShopNameWithPipe title="Hilfe" />
			<Container>
				<BreadCrumbs locale={locale} currentPath={currentPath} />
				<Box my={5}>
					<Typography variant="h5" component="h1" style={{ textAlign: "center" }}>
						Hallo{isLoggedIn ? ` ${firstName}` : null}, wie können wir Ihnen helfen?
					</Typography>
					<Box mt={2}>
						<p style={{ textAlign: "center", margin: "auto", maxWidth: 750 }}>
							Haben Sie eine Frage? Möchten Sie uns kontaktieren oder etwas
							zurückgeben? Benutzen Sie einfach unsere Suchfunktion oder durchstöbern
							Sie unser Hilfecenter.
						</p>
					</Box>
				</Box>
				<Box my={5} pb={5}>
					<Grid container spacing={3}>
						{helpCenterLinks.map((helpCenterLink) => {
							const { title, /* description, */ url, icon } = helpCenterLink
							return (
								<Grid item xs={12} sm={6} md={3} key={helpCenterLink.title}>
									<Link href={url} key={title}>
										<Box
											p={2}
											style={{
												boxShadow: "0px 0px 5px 0px rgba(0,0,0,0.15)",
												display: "flex",
											}}
										>
											<Icon path={icon} size={1} color="#4691CE" />
											<Box ml={1}>{title}</Box>
										</Box>
									</Link>
								</Grid>
							)
						})}
					</Grid>
				</Box>
			</Container>
		</>
	)
}

export default HelpCenterPage
